import en from "./locales/en";
import it from "./locales/it";

const translations = { en, it };

export type Locale = keyof typeof translations;
type TranslationKey = keyof typeof en;

const STORAGE_KEY = "llemma_locale";
const SUPPORTED: Locale[] = ["en", "it"];

function detectLocale(): Locale {
  const saved = localStorage.getItem(STORAGE_KEY) as Locale | null;
  if (saved && SUPPORTED.includes(saved)) return saved;
  for (const lang of navigator.languages) {
    const match = SUPPORTED.find(s => lang === s || lang.startsWith(s + "-"));
    if (match) return match;
  }
  return "en";
}

let currentLocale: Locale = detectLocale();
const listeners = new Set<() => void>();

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale) {
  currentLocale = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  listeners.forEach(fn => fn());
}

export function t(key: TranslationKey, vars?: Record<string, string | number>): string {
  const locale = translations[currentLocale] as Record<string, string>;
  let str: string = locale?.[key] ?? translations.en[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replace(`{${k}}`, String(v));
    }
  }
  return str;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export const locales: { code: Locale; label: string }[] = [
  { code: "en", label: "English" },
  { code: "it", label: "Italiano" },
];
